import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-gbp-review-detail-drawer',
  templateUrl: './review-detail-drawer.component.html',
  styleUrls: ['./review-detail-drawer.component.css'],
})
export class GbpReviewDetailDrawerComponent implements OnInit {
  review: any;
  action: any;
  loading: boolean = true;
  replyText: string = '';

  constructor(
    public dialogRef: MatDialogRef<GbpReviewDetailDrawerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dataService: DataService,
    private messageService: MessageService,
  ) {
    this.review = data.review;
  }

  ngOnInit(): void {
    this.loadDetails();
  }

  loadDetails() {
    this.loading = true;
    this.dataService
      .getData(`gbpReviews/${this.review._id}`)
      .subscribe((res) => {
        this.review = res.data;
        console.log('res', res);

        // Load associated local action (most recent pending/approved)
        this.dataService
          .getData(`localActions/review/${this.review._id}`)
          .subscribe((actionRes) => {
            console.log('actionRes', actionRes);
            if (actionRes.rst && actionRes.data) {
              this.action = actionRes.data;
              this.replyText = this.action.payloadDraft?.replyText || '';
            }
            this.loading = false;
          });
      });
  }

  approve() {
    this.dataService
      .postData(`localActions/approve/${this.action._id}`, {
        decision: 'approved',
        editedReplyText: this.replyText,
      })
      .subscribe((res) => {
        if (res.rst) {
          this.messageService.add('Action approved successfully', 'success');
          this.dialogRef.close(true);
        }
      });
  }

  reject() {
    this.dataService
      .postData(`localActions/approve/${this.action._id}`, {
        decision: 'rejected',
      })
      .subscribe((res) => {
        if (res.rst) {
          this.dialogRef.close(true);
        }
      });
  }

  regenerate() {
    this.dataService
      .putData(`localActions/regenerate/${this.action._id}`, {})
      .subscribe((res) => {
        if (res.rst) {
          this.messageService.add('Regeneration requested', 'info');
          this.dialogRef.close(true);
        }
      });
  }

  skip() {
    this.dataService
      .putData(`localActions/skip/${this.action._id}`, {})
      .subscribe((res) => {
        if (res.rst) {
          this.dialogRef.close(true);
        }
      });
  }

  close() {
    this.dialogRef.close();
  }
}
